import CovidPage from '../components/CovidPage';
import AOS from 'aos'
import { graphql } from 'gatsby'
import Layout from '../components/Layout';
import React, { PureComponent } from 'react'
import withLoading from '../hocs/withLoading'

import styles from './styles-about.module.css'

class Covid extends PureComponent {
  componentDidMount = () => {
    AOS.init({
      duration: 700,
      offset: 120,
    })
  }

  render() {
    const { pageContext, data, loading } = this.props

    return (
      <Layout pageContext={pageContext} loading={loading} location={this.props.location}>
        <div className={styles.background}>
          <CovidPage content={data.cockpitCovidPage} loading={loading} />
        </div>
      </Layout>
    )
  }
}

export default withLoading(Covid)

export const query = graphql`
    query {
        cockpitCovidPage(cockpitId: { eq: "5ebefa470ba41b500e3ae182" }) {
            primary {
              value
            }
            secondary {
              value
            }
            description {
              value {
                childMarkdownRemark {
                  html
                  htmlAst
                }
              }
            }
          }
    }
`
